import { NON_PLAYER_GENDER_WORK_OPTIONS } from '../../../../utils/constants';
import RadioGroup from '../../Custom/RadioGroup';
import { CONTRACT_STATUS_OPTIONS } from '../config/formConfig';
import FormField from './FormField';

const ClubSection = ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    userInfo,
    teams,
    selectTeam,
    selectClub,
    searchValue,
    errorMessage,
    isFetchingTeams,
    handleTeamChange,
    setSelectClub,
    setTeams,
    setSelectTeam,
    setNotFoundClubError,
    setSearchValue,
    getTeamsBasedOnSelectedClub,
    SelectWithPicture
}) => {
    // Handle club selection and update Formik fields
    const handleClubSelect = club => {
        setSelectClub(club);
        if (setFieldValue) {
            setFieldValue('clubName', club?.clubName || '');
            setFieldValue('clubId', club?.id || '');
        }
    };

    // Handle team selection and update Formik fields
    const handleTeamSelect = team => {
        setSelectTeam(team);
        if (setFieldValue) {
            setFieldValue('teamName', team?.teamName || '');
            setFieldValue('teamId', team?.id || '');
        }
    };

    // Enhanced team change handler
    const enhancedHandleTeamChange = event => {
        const selectedTeam =
            teams.find(item =>
                item?.teamName
                    ?.toLowerCase()
                    ?.includes(event.target.value?.toLowerCase())
            ) || {};

        handleTeamSelect(selectedTeam);
        handleTeamChange(event);
    };

    return (
        <section className='club-section'>
            {userInfo.userType !== 'NON_PLAYER' && (
                <h3 className='text-[14px] font-semibold my-5'>Club</h3>
            )}

            {userInfo.userType !== 'NON_PLAYER' && (
                <div
                    className='relative w-full mb-7 group'
                    data-field='contractStatus'
                    id='field-contractStatus'
                >
                    <label
                        className='text-sm text-gray-500'
                        htmlFor='contractStatus'
                    >
                        Contract Status
                    </label>
                    <div className='flex items-center w-full justify-between mt-3'>
                        <RadioGroup
                            name='contractStatus'
                            className='justify-between w-full'
                            value={
                                values.contractStatus || values.contractStatus
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            options={CONTRACT_STATUS_OPTIONS}
                        />
                    </div>
                    {errors.contractStatus && touched.contractStatus && (
                        <p className='absolute mt-1 text-red-600 text-xs'>
                            {errors.contractStatus}
                        </p>
                    )}
                </div>
            )}

            {userInfo.userType === 'NON_PLAYER' && (
                <FormField
                    type='radio'
                    name='gender'
                    label='I work in…'
                    addBottomBorder={false}
                >
                    <RadioGroup
                        name='gender'
                        className='justify-between w-full'
                        value={values.gender}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        options={NON_PLAYER_GENDER_WORK_OPTIONS}
                    />
                </FormField>
            )}

            {/* Football Club section - only show for non-players or when contract status is CONTRACT or NON_CONTRACT */}
            {(userInfo.userType === 'NON_PLAYER' ||
                (userInfo.userType !== 'NON_PLAYER' &&
                    values.contractStatus &&
                    values.contractStatus !== 'UNSIGNED')) && (
                <FormField
                    name='clubName'
                    addBottomBorder={false}
                    label={
                        userInfo.userType !== 'NON_PLAYER'
                            ? 'Football Club'
                            : 'club/Organisation'
                    }
                    error={errors.clubName}
                    touched={touched.clubName}
                    required={
                        userInfo.userType !== 'NON_PLAYER' &&
                        (values.contractStatus === 'CONTRACT' ||
                            values.contractStatus === 'NON_CONTRACT')
                    }
                >
                    <SelectWithPicture
                        userInfo={userInfo}
                        setSelectClub={handleClubSelect}
                        selectClub={selectClub}
                        setTeams={setTeams}
                        borderColor={errors.clubName ? 'border-red-600' : ''}
                        className='absolute z-10'
                        clubsByGender
                        setSelectTeam={handleTeamSelect}
                        setNotFoundClubError={setNotFoundClubError}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        getTeamsBasedOnSelectedClub={
                            getTeamsBasedOnSelectedClub
                        }
                    />
                </FormField>
            )}

            {/* Teams section - only show for non-players or when contract status is CONTRACT or NON_CONTRACT */}
            {(userInfo.userType === 'NON_PLAYER' ||
                (userInfo.userType !== 'NON_PLAYER' &&
                    values.contractStatus &&
                    values.contractStatus !== 'UNSIGNED')) &&
                !!teams?.length &&
                searchValue.length > 0 && (
                    <FormField
                        name='teamName'
                        label='Team'
                        error={errors.teamName}
                        touched={touched.teamName}
                        required={
                            (!!selectClub?.clubName || !!values.clubName) &&
                            selectClub?.typeOfOrg !== 'COMPANY'
                        }
                    >
                        <select
                            onChange={enhancedHandleTeamChange}
                            className='appearance-none bg-transparent w-full text-gray-700 py-1 pl-2 leading-tight focus:outline-none'
                            value={
                                selectTeam?.teamName || values.teamName || ''
                            }
                        >
                            <option value=''>Select team</option>
                            {teams
                                .sort((a, b) => b.index - a.index)
                                .map((team, idx) => (
                                    <option key={idx} value={team?.teamName}>
                                        {team?.teamName}
                                    </option>
                                ))}
                        </select>
                        {teams.length === 0 ? (
                            <div className='text-xs text-red-600 mt-1'>
                                <p>Team not in database.</p>
                                <p>
                                    Please contact{' '}
                                    <a
                                        className='text-red-600'
                                        href={`mailto:hello@playerapp.co?subject=Add team to database&body=Hello PLAYER, \n Please add '${searchValue}' to your system`}
                                    >
                                        hello@playerapp.co{' '}
                                    </a>
                                    to get it added.
                                </p>
                            </div>
                        ) : (
                            ''
                        )}
                    </FormField>
                )}

            {/* Contract Expiry section - only show for players with CONTRACT status */}
            {userInfo.userType !== 'NON_PLAYER' &&
                values.contractStatus === 'CONTRACT' && (
                    <FormField
                        name='contractExpiry'
                        label='Contract Expiry Date'
                        value={values?.contractExpiry}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder='eg. July 2025 (Leave blank if not applicable)'
                        error={errors.contractExpiry}
                        touched={touched.contractExpiry}
                    />
                )}
        </section>
    );
};

export default ClubSection;
